/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from 'react'
import Main from '../../../components/HOC/Main'
import BlogTypeForm from '../../../components/pages/BlogTypeForm'
import { useDispatch, useSelector } from 'react-redux'
import Button from '../../../components/common/Button';
import { selectSelectedBlogType, setSelectedBlogType, toggleBlogTypeSlide, toggleCommonDeleteModal } from '../../../store/slices/common';
import CustomTable from '../../../components/common/CustomTable';
import useApiRequest from '../../../store/slices/hook/useApiRequest';
import { clearBlogTypeData, deleteBlogType, fetchBlogType, selectBlogTypeData, setBlogTypeData } from '../../../store/slices/api/inner/blogTypeSlice';
import TableAction from '../../../components/TableAction';
import { FaPlus } from 'react-icons/fa';
import { formateDate } from '../../../components/common/FormateDate';

export default function BlogTypePage() {
  const dispatch = useDispatch();
  const blogTypeData = useSelector(selectBlogTypeData);
  const selectedBlogType = useSelector(selectSelectedBlogType)

  const { handleSubmit: fetchData } = useApiRequest({
    apiAction: fetchBlogType,
    setValueAction: setBlogTypeData,
    clearValueActionOnError: clearBlogTypeData,
    isForm: false,
    successMessage: false,
  });

    // delete start
    const openDeleteModal = (data) => {
      dispatch(setSelectedBlogType(data))
      dispatch(toggleCommonDeleteModal())
      
    }
    const cancelDeleteModal = () => {
      dispatch(setSelectedBlogType(null))
      dispatch(toggleCommonDeleteModal())
    }
  
    const afterAPICall = (res) => {
      fetchData()
      dispatch(setSelectedBlogType(null))
      dispatch(toggleCommonDeleteModal())
    }
    
    const { handleSubmit: handleDelete } = useApiRequest({
      apiAction: deleteBlogType,
      isForm: false,
      afterAPICall,
    });
    // delete end  

  const handleEdit = (data) => {
    dispatch(setSelectedBlogType(data));
    dispatch(toggleBlogTypeSlide());
  }

  const handleAdd = () => {
    dispatch(setSelectedBlogType(null));
    dispatch(toggleBlogTypeSlide())
  }

  const columns = useMemo(() => [
    {
      accessorKey: 'blog_category_name',
      filterFn: 'equalsString',
      header:"blog category name"
    },
    {
      accessorKey: 'createdAt',
      cell: info => formateDate(info.getValue()),
      filterFn: 'includesStringSensitive',
    },
    {
      accessorKey: 'updatedAt',
      cell: info => formateDate(info.getValue()),
      filterFn: 'includesStringSensitive',
    },

    {
      id: 'actions',
      cell: info => <TableAction handleEditButton={() => { handleEdit(info?.row?.original) }} handleDeleteButton={() => { openDeleteModal(info?.row?.original) }} />,
      header: () => <span>Actions</span>,
    }, 
  ], []);

  useEffect(() => {
    fetchData();
  }, [])

  return (
    <Main crumbs={[{ title: "blog" }, { title: "blog types" }]} handleDelete={() => {handleDelete({ blogTypeId: selectedBlogType.blog_category_id }) }} handleCandleDelete={cancelDeleteModal}>
      <CustomTable columns={columns} data={blogTypeData} tableTop={<Button onClick={handleAdd} size='small'><FaPlus /> Add Blog Type</Button>} />
      <BlogTypeForm defaultData={selectedBlogType} fetchData={fetchData} />
    </Main>
  )
}
